import React from 'react';
import { useEffect, useState } from 'react';

const Wave = ({ isStart, isCanva }) => {
  const [darkMode, setDarkMode] = useState(
      () => localStorage.getItem("darkMode") === "true" ||
      window.matchMedia("(prefers-color-scheme: dark)").matches
    );
  
    useEffect(() => {
      // Vérifie si le mode sombre est activé via localStorage ou la préférence système
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  
      const handleChange = (e) => {
        setDarkMode(e.matches);
        localStorage.setItem("darkMode", e.matches); // Stocke la préférence
      };
  
      mediaQuery.addEventListener("change", handleChange);
  
      return () => mediaQuery.removeEventListener("change", handleChange);
    }, []);


    const getImageSrc = () => {
      if (darkMode) {
        // Mode sombre
        if (isCanva) {
          // Canva, mode sombre
          return isStart
            ? '/img/autres/wave-blue-canva-dark-start.svg'  // Début, Canva, mode sombre
            : '/img/autres/wave-blue-canva-dark-end.svg';   // Fin, Canva, mode sombre
        } else {
          // Pokelu, mode sombre
          return isStart
            ? '/img/autres/wave-blue-pokelu-dark-start.svg'  // Début, Pokelu, mode sombre
            : '/img/autres/wave-blue-pokelu-dark-end.svg';   // Fin, Pokelu, mode sombre
        }
      } else {
        // Mode clair
        if (isCanva) {
          // Canva, mode clair
          return isStart
            ? '/img/autres/wave-white-blue-canva.svg'        // Début, Canva, mode clair
            : '/img/autres/wave-blue-canva-white.svg';       // Fin, Canva, mode clair
        } else {
          // Pokelu, mode clair
          return isStart
            ? '/img/autres/wave-white-blue.svg' // Début, Pokelu, mode clair
            : '/img/autres/wave-blue-white.svg';  // Fin, Pokelu, mode clair
        }
      }
    };

  return <img className="accueil-img" src={getImageSrc()} alt="Wave" />;
};

export default Wave;